module.exports = __webpack_public_path__ + "img/crv20.20e53442.png";